// src/components/Detail/PurchaseActions.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faCheck, faExclamationTriangle, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

const PurchaseActions = ({ tallaSeleccionada, cantidad, onQuantityChange, onAddToCart }) => {
    const stock = tallaSeleccionada?.stock || 0;
    const isAvailable = stock > 0 && tallaSeleccionada;

    const handleQuantity = (newQuantity) => {
        if (newQuantity < 1) newQuantity = 1;
        if (newQuantity > stock) {
            newQuantity = stock;
            toast.warn('Cantidad ajustada al stock disponible', { autoClose: 1000 });
        }
        onQuantityChange(newQuantity);
    };

    // En PurchaseActions.js

return (
    <>
        {/* --- Estado de Disponibilidad (sin cambios) --- */}
        <div className="modern-availability">
            {tallaSeleccionada ? (
                stock > 0 ? (
                    <div className="in-stock">
                        <FontAwesomeIcon icon={faCheck} />
                        <span>¡Disponible! Quedan {stock} unidades.</span>
                    </div>
                ) : (
                    <div className="out-of-stock">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span>Agotado en esta talla.</span>
                    </div>
                )
            ) : (
                <div className="out-of-stock">
                    <FontAwesomeIcon icon={faExclamationTriangle} />
                    <span>Selecciona una talla para ver la disponibilidad.</span>
                </div>
            )}
        </div>

        {/* --- ✨ Nueva Barra de Acciones Unificada --- */}
        {isAvailable && (
            <div className="modern-action-bar">
                {/* Selector de Cantidad */}
                <div className="quantity-controls">
                    <button className="quantity-btn" onClick={() => handleQuantity(cantidad - 1)} disabled={cantidad <= 1}>
                        <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <input type="number" className="quantity-input" value={cantidad} onChange={(e) => handleQuantity(parseInt(e.target.value) || 1)} min="1" max={stock} />
                    <button className="quantity-btn" onClick={() => handleQuantity(cantidad + 1)} disabled={cantidad >= stock}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>
                
                {/* Botón de Compra */}
                <button onClick={onAddToCart} className='btn btn-primary' disabled={!isAvailable}>
                    <FontAwesomeIcon icon={faShoppingCart} />
                    <span>Añadir {cantidad > 1 ? `(${cantidad})` : ''}</span>
                </button>
            </div>
        )}
    </>
);
};

export default React.memo(PurchaseActions);